import { AfterViewInit, Component } from '@angular/core';
import { SwiperInitService } from 'src/app/shared/swiper-init.service';

declare var $: any;

@Component({
  selector: 'app-our-process',
  templateUrl: './our-process.component.html',
  styleUrl: './our-process.component.scss'
})
export class OurProcessComponent implements AfterViewInit {
  constructor(private swiperInitService: SwiperInitService) { }
  ngAfterViewInit(): void {
    this.swiperInitService.initSliders();
  }
  ngOnInit(): void {

  }
}